import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTableCellsLarge } from '@fortawesome/free-solid-svg-icons/faTableCellsLarge';
import type { IconProps } from '../../types';

export function TableCellsLargeIcon({ 
  className, 
  size = 24, 
  color,
  'aria-label': ariaLabel = 'Grid',
}: IconProps) {
  return (
    <FontAwesomeIcon 
      icon={faTableCellsLarge}
      className={className}
      style={{ 
        width: typeof size === 'number' ? size : undefined,
        height: typeof size === 'number' ? size : undefined,
      }}
      color={color}
      aria-label={ariaLabel}
      role="img"
    />
  );
}
